import { object, string } from 'zod';

import { IS_REQUIRED, isStringLengthUpTo } from '@occc-app/lib/constants/validationMessages';

export const OfferNameAndDescriptionSchema = object({
  name: string({ required_error: IS_REQUIRED })
    .trim()
    .min(1, IS_REQUIRED)
    .max(255, isStringLengthUpTo(255)),
  description: string().max(1000).nullable().optional(),
});
